import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import UserRepository from "../../../repositories/UserRepository";

const UserListView = () => {

	const repository = new UserRepository();
	const {t}  = useTranslation();

	const {items, totalCount, itemsOnPage, onPage, isSearching, onFilterChangedHandler, onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, {});

	const columns = [
        { field: 'DisplayName', headerName: t('Name'), width: 350, sortable: false },
        { field: 'Roles', headerName: t('Roles'), width: 300, sortable: false,
          renderCell: (cell) => {
              return cell.value.join(", ");
          }
      }
    ];

	return (
	    <GridSkeleton title={t("Users")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} showQuerySearch={true} showSort={false} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default UserListView;